import { render, staticRenderFns } from "./settings-templates-sms.vue?vue&type=template&id=2d341c3a&"
import script from "./settings-templates-sms.ts?vue&type=script&lang=ts&"
export * from "./settings-templates-sms.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports